
import * as imgixRuntime$_7bjHJ0buO_HaaDl2q2ycwbY1_eMJYjAJ5tBH_DVWQQw from '/opt/build/repo/node_modules/@nuxt/image/dist/runtime/providers/imgix'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 576,
    "md": 768,
    "lg": 992,
    "xl": 1200,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imgix",
  "domains": [
    "mallmaverick.imgix.net"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['imgix']: { provider: imgixRuntime$_7bjHJ0buO_HaaDl2q2ycwbY1_eMJYjAJ5tBH_DVWQQw, defaults: {"baseURL":""} }
}
        